import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import api from '../../../lib/api'

export default function DNSCheckStep({ onDone }) {
  const [grade, setGrade] = useState(null)
  const [loading, setLoading] = useState(true)
  const [err, setErr] = useState(null)

  useEffect(() => {
    let cancelled = false
    ;(async () => {
      try {
        const accts = (await api.get('/email/accounts')).data || []
        if (!accts.length) { if (!cancelled) { setErr('Connect a mailbox first.'); setLoading(false) } ; return }
        const res = await api.post('/dns/check', { email: accts[0].email })
        if (!cancelled) { setGrade(res.data?.grade || '?'); setLoading(false) }
      } catch (e) {
        if (!cancelled) { setErr('DNS check failed.'); setLoading(false) }
      }
    })()
    return () => { cancelled = true }
  }, [])

  return (
    <div>
      <p style={{ color: '#aaa', fontSize: 14, lineHeight: 1.6 }}>
        SPF, DKIM, and DMARC records protect your sending reputation. We'll
        score your domain and tell you what's missing.
      </p>
      <div style={{ marginTop: 24, padding: 20, background: '#1a1d29', borderRadius: 8 }}>
        <div style={{ fontSize: 11, color: '#888', textTransform: 'uppercase', letterSpacing: 1 }}>Grade</div>
        <div style={{ fontSize: 38, fontWeight: 700, color: grade && 'ABC'.includes(grade) ? '#22c55e' : '#f59e0b', marginTop: 4 }}>
          {loading ? '…' : (err ? '!' : grade)}
        </div>
        {err && <div style={{ color: '#f87171', fontSize: 12, marginTop: 6 }}>{err}</div>}
      </div>
      <div style={{ marginTop: 20 }}>
        <Link to="/dns-health" onClick={onDone}
          style={{ color: '#3b82f6', textDecoration: 'none', fontSize: 14, fontWeight: 600 }}>
          Open DNS Health for details →
        </Link>
      </div>
    </div>
  )
}
